import { Routes } from "@angular/router";
import { AuthGuard } from "@core/auth-guard";
import AddressesComponent from "@features/users/addresses/addresses.component";

export const routes: Routes = [
  {
    path: "login",
    loadComponent: async () => await import("./features/login/login.component"),
  },
  {
    path: "dashboard",
    loadComponent: async () =>
      await import("../app/features/main/main.component"),
    canActivate: [AuthGuard],
    children: [
      {
        path: "setting",
        loadComponent: async () =>
          await import("./features/setting/setting.component"),
      },
      {
        path: 'support/create',
         loadComponent: async () =>
          await import("./features/support/support-create-component/support-create.component"),
      },
      {
        path: "support/:id",
        loadComponent: async () =>
          await import(
            "./features/support/support-detail/support-detail.component"
          ),
      },
      {
        path: "support",
        loadComponent: async () =>
          await import("./features/support/support.component"),
      },
      {
        path: "contact-us",
        loadComponent: async () =>
          await import("./features/contact-us/contact-us.component"),
      },
      {
        path: "profile",
        loadComponent: async () =>
          await import("./features/edit-profile/edit-profile.component"),
      },
      {
        path: "change-password",
        loadComponent: async () =>
          await import("./features/change-password/change-password.component"),
      },
      {
        path: "users",
        loadComponent: () =>
          import("./features/users/users.component").then((m) => m.default),
      },
      {
        path: "shipments",
        loadComponent: () =>
          import("./features/shipping-companies-list/shipping-companies-list.component").then((m) => m.default),
      },
      {
        path: "users/:id/addresses",
        loadComponent: () =>
          import("./features/users/addresses/addresses.component").then((m) => m.default),
      },
      {
        path: "categories",
        loadComponent: async () =>
          await import(
            "./features/categories/category-list/category-list.component"
          ),
      },
      {
        path: "sliders",
        loadComponent: async () =>
          await import("./features/sliders/sliders.component"),
      },
      {
        path: "tags",
        loadComponent: async () =>
          await import("./features/products/product-tag-list/product-tag-list.component"),
      },
      {
        path: "orders",
        loadComponent: async () =>
          await import("./features/order-management/order-management.component"),
      },
      {
        path: "orders/:orderId",
        loadComponent: async () =>
          await import("./features/order-management/order-detail-page/order-detail-page.component"),
      },
      {
        path: "menus",
        loadComponent: () =>
          import("./features/menus/menu-list/menu-list.component").then(
            (m) => m.MenuListComponent,
          ),
      },
      {
        path: "reviews",
        loadComponent: () =>
          import("./features/review/review-list/review-list.component").then(
            (m) => m.ReviewListComponent,
          ),
      },
      {
        path: "brands",
        loadComponent: () =>
          import("./features/brands/brand-list/brand-list.component").then(
            (m) => m.BrandListComponent,
          ),
      },
      {
        path: "invoices",
        loadComponent: () =>
          import("./features/invoices/invoices-list/invoices-list.component").then(
            (m) => m.InvoicesListComponent,
          ),
      },
      {
        path: "products",
        loadComponent: () =>
          import(
            "./features/products/product-list/product-list.component"
          ).then((m) => m.ProductListComponent),
      },
      {
        path: "products/:id",
        loadComponent: () =>
          import(
            "./features/products/product-edit/product-edit.component"
          ).then((m) => m.ProductEditComponent),
      },
      {
        path: "attributes",
        loadComponent: () =>
          import(
            "./features/attributes/attribute-list/attribute-list.component"
          ).then((m) => m.AttributeListComponent),
      },
      {
        path: "messages",
        loadComponent: async () =>
          await import("./features/message/message.component"),
      },
      {
        path: "messages/add",
        loadComponent: async () =>
          await import("./features/message/add-message/add-message.component"),
      },
      {
        path: "home",
        loadComponent: async () =>
          await import("./features/home/home.component"),
      },
      {
        path: "**",
        redirectTo: "/home",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "**",
    redirectTo: "/login",
    pathMatch: "full",
  },
];
